import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Gift, Copy, Share2 } from "lucide-react";

export default function CreatorReferralCard() {
  const [ref, setRef] = useState(null);
  useEffect(() => { api.get("/referrals/me").then((r) => setRef(r.data)).catch(() => {}); }, []);
  if (!ref?.creator_bonus) return null;
  const link = `${window.location.origin}/auth?mode=signup&role=creator&ref=${ref.code}`;
  const b = ref.creator_bonus;
  const copy = async () => { try { await navigator.clipboard.writeText(link); toast.success("Referral link copied"); } catch { toast.error("Couldn't copy — long-press the link instead"); } };
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title: "Join me on Nexus", text: "Get paid brand deals with escrow protection — you keep 100%.", url: link }); } catch { /* cancelled */ } } else copy();
  };
  return (
    <div className="glass rounded-2xl p-5" data-testid="creator-referral-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-nexus-pink/10 border border-nexus-pink/30 flex items-center justify-center shrink-0"><Gift className="h-5 w-5 text-nexus-pink" /></div>
          <div>
            <div className="text-sm font-semibold">Refer a creator, earn {b.pct}% of their payouts for {b.window_months} months</div>
            <div className="text-xs text-zinc-400 mt-0.5">Paid into this wallet every time they get paid. They lose nothing — it comes out of the brand's platform fee.</div>
          </div>
        </div>
        <div className="flex gap-6 text-center">
          <div><div className="font-display font-bold text-xl" data-testid="referral-bonus-total">£{b.bonus_total.toFixed(2)}</div><div className="text-[10px] uppercase tracking-widest text-zinc-500">earned</div></div>
          <div><div className="font-display font-bold text-xl" data-testid="referral-active-count">{b.active_referred_creators}</div><div className="text-[10px] uppercase tracking-widest text-zinc-500">active referrals</div></div>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <div className="flex-1 rounded-full bg-black/40 border border-white/10 px-4 py-2 text-xs text-zinc-300 font-mono truncate" data-testid="referral-link">{link}</div>
        <Button size="sm" onClick={copy} className="rounded-full nexus-gradient text-white border-0" data-testid="referral-copy-btn"><Copy className="h-3.5 w-3.5 mr-1.5" /> Copy</Button>
        <Button size="sm" variant="outline" onClick={share} className="rounded-full border-white/15 text-white" data-testid="referral-share-btn"><Share2 className="h-3.5 w-3.5 mr-1.5" /> Share</Button>
      </div>
    </div>
  );
}
